export default "__VITE_ASSET__7707b230__"